// extracted by mini-css-extract-plugin
module.exports = {"Hotkey":"Hotkey__2t_O_"};